module.exports = __webpack_public_path__ + "img/titlev5.97a9a239.png";